import axios from 'axios';
import {
  SUBMIT_AGAIN_REQUEST,
  SUBMIT_AGAIN_SUCCESS,
  SUBMIT_AGAIN_FAIL,
} from "../constants/submitAgainConstants";

export const submitDailyStatusAgain = (userId, requestBody) => async (dispatch, getState) => {
  try {
    dispatch({ type: SUBMIT_AGAIN_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.put(
      `/api/users/${userId}/dailystatus`,
      requestBody,
      config
    );

    dispatch({
      type: SUBMIT_AGAIN_SUCCESS,
      payload: data,
    });

    return data; // Return the response data to the caller
  } catch (error) {
    dispatch({
      type: SUBMIT_AGAIN_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });

    throw error; // Re-throw the error to the caller
  }
};
